<template>
  <div>
    <el-form style="margin: 20px 40px 0 0" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="护理对象" prop="pId">
            <el-select v-fixZoom :disabled="openType === 2" v-model="addEditForm.pId" filterable placeholder="请选择" style="width:100%;" @change="changeElderly">
              <el-option v-for="item in elderlyArr" :key="item.index" :label="item.name" :value="item.id">
                <span>{{ getSelectElderlyShow(item) }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="护理人员" prop="svsEspId">
            <el-select v-fixZoom v-model="addEditForm.svsEspId" filterable placeholder="请选择" style="width:100%;">
              <el-option v-for="item in servicePersonArr" :key="item.index" :label="item.service_personnel_name" :value="item.id">
                <span>{{ getSelectServicePersonShow(item) }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="护理类别" prop="sId">
            <el-select v-fixZoom :disabled="openType === 2" v-model="addEditForm.sId" filterable placeholder="请选择" style="width:100%;" @change="changeEservice">
              <el-option v-for="item in eserviceArr" :key="item.index" :label="item.s_name" :value="item.s_id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="护理时间" prop="svsTime">
            <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.svsTime"
                            type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="xxxx-xx-xx xx:xx:xx">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="护理项目" prop="" v-if="svsItemArr.length !== 0">
        <el-checkbox-group v-model="addEditForm.svsItems">
          <el-checkbox v-for="item in svsItemArr" :label="item" :key="item">{{item}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="护理备注" prop="">
        <el-input type="textarea" :rows="2" v-model="addEditForm.svsRemarks" placeholder="输入护理备注"></el-input>
      </el-form-item>
    </el-form>
    <div style="height: 50px">
      <el-row v-if="openType !== 0" style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
      <el-row v-else style="margin: 0 20px">
        <div class="cancel-btn" style="float: right" @click="closeAddEdit()">
          <span>关闭</span>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import {queryelderlyhasbed} from '../../../api/yanglaoyuan/elderly'
import {
  queryeservicelist,
  queryeservicepersonsetinglist,
  updateeservicepersonrecord
} from '../../../api/yanglaoyuan/eservice'
import {queryserviceperson} from '../../../api/yanglaoyuan'

export default {
  name: 'addEditServiceRecord',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      eId: 0,
      espId: 0,
      espName: '',
      // 打开类型 0查看 1新增 2编辑
      openType: 0,
      row: '',
      elderlyArr: [],
      oinginEServiceArr: [],
      eserviceArr: [],
      servicePersonArr: [],
      svsItemArr: [],

      addEditForm: {
        pId: '',
        svsEspId: '',
        sId: '',
        svsTime: '',
        svsRemarks: '',
        svsItems: []
      },
      addEditRules: {
        // sName: [{ required: true, message: '请输入服务名称', trigger: 'blur' }]
        pId: [{required: true, message: '请选择护理对象', trigger: 'change'}],
        svsEspId: [{required: true, message: '请选择护理人员', trigger: 'change'}],
        sId: [{required: true, message: '请选择护理类别', trigger: 'change'}],
        svsTime: [{required: true, message: '请选择护理时间', trigger: 'change'}]
      }
    }
  },
  created () {
    this.getStartData()
  },
  methods: {
    getStartData () {
      let loginResp = this.$store.state.user.LoginResp
      this.eId = loginResp.entity_id
      this.espId = loginResp.syspersonid
      this.espName = loginResp.personname

      this.openType = this.addEditObj.openType
      this.row = this.addEditObj.row

      if (this.openType === 2) {
        this.addEditForm.pId = this.row.pid
        this.addEditForm.svsEspId = this.row.svs_esp_id
        this.addEditForm.sId = this.row.s_id
        this.addEditForm.svsTime = this.row.svs_time
        this.addEditForm.svsRemarks = this.row.svs_remarks

        if (this.row.svs_items && this.row.svs_items.length !== 0) {
          this.addEditForm.svsItems = this.row.svs_items.split('|')
        }
      }

      this.getElderlyData()
      this.getEserviceListData()
      this.getServicePersonData()
    },
    getSelectElderlyShow (item) {
      let elderlyName = item.name && item.name !== '' ? item.name : '--'
      let buildName = item.build_name && item.build_name !== '' ? item.build_name : '--'
      let floorName = item.floor_name && item.floor_name !== '' ? item.floor_name : '--'
      let roomName = item.room && item.room !== '' ? item.room : '--'
      let bedName = item.bed_name && item.bed_name !== '' ? item.bed_name : '--'
      return elderlyName + ' / ' + buildName + '--' + floorName + '--' + roomName + '--' + bedName
    },
    getSelectServicePersonShow (item) {
      let servicePersonName = item.service_personnel_name && item.service_personnel_name !== '' ? item.service_personnel_name : '--'
      let idNumber = item.service_personnel_identity_card_number && item.service_personnel_identity_card_number !== '' ? item.service_personnel_identity_card_number.replace(/^(.{4})(?:\d+)(.{4})$/, '$1**********$2') : '--'
      return servicePersonName + ' / ' + idNumber
    },
    changeElderly () {
      this.addEditForm.sId = ''
      this.svsItemArr = []
      this.getEServicePersonSetingListData(this.addEditForm.pId)
    },
    changeEservice () {
      let that = this
      this.svsItemArr = []
      if (this.openType !== 2) {
        this.addEditForm.svsItems = []
      }
      let eService = this.eserviceArr.find(r => r.s_id === this.addEditForm.sId)
      if (eService) {
        if (eService.sub_items.length !== 0) {
          eService.sub_items.split('|').forEach(item => {
            that.svsItemArr.push(item)
          })
        }
      }
    },

    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.openType === 1) {
            this.sendAdd()
          } else if (this.openType === 2) {
            this.sendEdit()
          }
        }
      })
    },
    sendAdd () {
      let svsItems = ''
      this.addEditForm.svsItems.forEach(item => {
        if (svsItems.length !== 0) {
          svsItems += '|'
        }
        svsItems += item
      })
      let elderly = this.elderlyArr.find(r => r.id === this.addEditForm.pId)
      let svsEsp = this.servicePersonArr.find(r => r.id === this.addEditForm.svsEspId)
      let data = {
        oper_type: 0,
        eid: this.eId,
        pid: this.addEditForm.pId,
        cin_id: elderly.checkinid,
        s_id: this.addEditForm.sId,
        svs_time: this.addEditForm.svsTime,
        svs_items: svsItems,
        svs_remarks: this.addEditForm.svsRemarks,
        svs_esp_id: this.addEditForm.svsEspId,
        svs_esp_name: svsEsp.service_personnel_name,
        esp_id: this.espId,
        esp_name: this.espName
      }
      updateeservicepersonrecord(data).then(res => {
        this.$notify({title: '成功', message: '成功新建该护理记录', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },
    sendEdit () {
      let svsItems = ''
      this.addEditForm.svsItems.forEach(item => {
        if (svsItems.length !== 0) {
          svsItems += '|'
        }
        svsItems += item
      })
      let elderly = this.elderlyArr.find(r => r.id === this.addEditForm.pId)
      let svsEsp = this.servicePersonArr.find(r => r.id === this.addEditForm.svsEspId)
      let data = {
        oper_type: 1,
        id: this.row.id,
        eid: this.eId,
        pid: this.addEditForm.pId,
        cin_id: elderly.checkinid,
        s_id: this.addEditForm.sId,
        svs_time: this.addEditForm.svsTime,
        svs_items: svsItems,
        svs_remarks: this.addEditForm.svsRemarks,
        svs_esp_id: this.addEditForm.svsEspId,
        svs_esp_name: svsEsp.service_personnel_name,
        esp_id: this.espId,
        esp_name: this.espName
      }
      updateeservicepersonrecord(data).then(res => {
        this.$notify({title: '成功', message: '成功修改该护理记录', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },

    // 访问接口
    // 查询老人
    getElderlyData () {
      let data = {
        e_id: this.eId
      }
      queryelderlyhasbed({}, data).then(res => {
        this.elderlyArr = res.data.elderly
      })
    },
    // 查询护理项目
    getEserviceListData () {
      let params = {
      }
      let data = {
        eid: this.eId
      }
      queryeservicelist(params, data).then(async res => {
        this.oinginEServiceArr = res.data.arrdata
        if (this.openType === 2) {
          await this.getEServicePersonSetingListData(this.addEditForm.pId)
          this.changeEservice()
        }
      })
    },
    // 获取入住的个人护理项目
    async getEServicePersonSetingListData (id) {
      let that = this
      this.eserviceArr = []
      this.oinginEServiceArr.forEach(eservice => {
        that.eserviceArr.push(this.clone(eservice))
      })
      let params = {}
      let data = {
        eid: this.eId,
        id1: id
      }
      await queryeservicepersonsetinglist(params, data).then(res => {
        let arrData = res.data.arrdata
        this.eserviceArr.forEach(item => {
          let eService = arrData.find(r => r.s_id === item.s_id)
          item.s_name = eService ? item.s_name + '【计划内】' : item.s_name.replace('【计划内】', '')
          if (eService) {
            eService.select_items.split('|').forEach(selectItem => {
              if (item.sub_items.indexOf(selectItem) === -1) {
                if (item.sub_items.length !== 0) {
                  item.sub_items += '|'
                }
                item.sub_items += selectItem
              }
            })
          }
        })
        this.eserviceArr.sort((a, b) => {
          if (a.s_name.indexOf('【计划内】') !== -1) {
            if (b.s_name.indexOf('【计划内】') !== -1) {
              if (a.s_id < b.s_id) return -1
              else return 1
            } else {
              return -1
            }
          } else {
            if (a.s_id < b.s_id) return -1
            else return 1
          }
        })
      })
    },
    // 查询机构人员
    getServicePersonData () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        e_id: this.eId
      }
      queryserviceperson(params, data).then(res => {
        this.servicePersonArr = res.data.serviceperson
        if (this.openType === 2) {
          this.changeEservice()
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditServiceRecord.vue